import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_LISTING_UPDATE_GTM_EMAIL_SENT_TO_PARTNER } from 'api/actionTypes';

export default async function updateGoingToMarketEmailSentToPartner(
  { state, apiClient },
  { marketingListingId, marketingItemsEmailSentToPartner },
) {
  typeCheck('marketingListingId::PositiveNumber', marketingListingId);
  typeCheck('marketingItemsEmailSentToPartner::Boolean', marketingItemsEmailSentToPartner);

  return apiClient.postWithState({
    action: SR_API_ACTION_LISTING_UPDATE_GTM_EMAIL_SENT_TO_PARTNER,
    state: state,
    payload: {
      marketingListingId,
      marketingItemsEmailSentToPartner,
    },
  });
}
